import { AppService } from './../../../core/app.service';
import { Component, input, OnInit, output } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderComponent } from "../../ui/loader/loader.component";
import { StructureProgammatiqueService } from '../../../services/structureProgrammatiquesService';
import { StructureProgrammatiqueResponse } from '../../../data/http/responses/structureprogrammatique.res';
import { UiButtonComponent } from '../../button/button.component';
import { routeAlias } from '../../../../routesalias';

@Component({
  selector: 'app-recapactivities',
  imports: [MatIcon, LoaderComponent, UiButtonComponent, DatePipe],
  templateUrl: './recapactivities.component.html',
  styleUrl: './recapactivities.component.css'
})
export class RecapactivitiesComponent implements OnInit {
  activityData = input<any>();
  submitFinalActivity = output<void>();
  isLoading = input<boolean>(false);
  isLoadingIntervention = false;

  /* structures: StructureProgrammatiqueResponse[] = []; */
  interventionParent?: StructureProgrammatiqueResponse;
  displayData: any;


  constructor(
    private structureProgrammatiqueService: StructureProgammatiqueService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }



 /*  private flattenStructures(
    structures: StructureProgrammatiqueResponse[],
    parentId: string | null = null
  ): StructureProgrammatiqueResponse[] {
    let flattened: StructureProgrammatiqueResponse[] = [];
    for (const structure of structures) {
      const currentStructure: StructureProgrammatiqueResponse = { ...structure, parent: parentId };
      flattened.push(currentStructure);
      if (structure.enfant?.length > 0) {
        flattened = flattened.concat(this.flattenStructures(structure.enfant, structure.id));
      }
    }
    return flattened;
  } */

  ngOnInit(): void {
    this.displayData = this.activityData();
    this.loadStructures();
  }



  loadStructures(): void {
    const selectedId = this.displayData?.generales?.typeInterventionSelect;
    if (!selectedId) return;
    this.isLoadingIntervention = true;
    this.structureProgrammatiqueService.getLightById(this.appService.getAppId(), selectedId).subscribe({
      next: (response: any) => {
        this.interventionParent = response.data;
        this.isLoadingIntervention = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement de la structure :', error);
        this.isLoadingIntervention = false;
      }
    });
  }
  /** Vérifie que les 3 blocs requis sont bien chargés/remplis */
  get isDataComplete(): boolean {
    const d = this.displayData;
    return !!(
      d?.generales &&
      d?.activites &&
      d?.budgets
    );
  }

  /** Revenir à l'étape précédente */
  goBack(): void {
    this.router.navigate([], {
      queryParams: { step: 'budgets' },
      relativeTo: this.route
    });
  }

  /** Aller à la première étape */
  goToStart(): void {
    this.router.navigate([], {
      queryParams: { step: 'generales' },
      relativeTo: this.route
    });
  }

  onConfirmSubmit(): void {
    this.submitFinalActivity.emit();
  }
}